// Discreet ownership + branding used across the app.
// Product name "Your Life Journeys Matter" stays most prominent;
// "A BrightHarbor creation" is the quiet umbrella endorsement.

export function BrandLockup({ className = "", onClick }) {
  return (
    <div
      data-testid="brand-lockup"
      onClick={onClick}
      className={`flex items-center gap-2.5 ${onClick ? "cursor-pointer" : ""} ${className}`}
    >
      <img
        src="/brand/yljm-emblem.png"
        alt="Your Life Journeys Matter emblem"
        className="h-9 w-9 shrink-0 object-contain"
      />
      <div className="min-w-0 leading-tight">
        <div className="whitespace-nowrap font-serif text-[15px] text-[#2C2A28] sm:text-lg">
          Your Life Journeys Matter<sup className="ml-0.5 align-top text-[0.55em]">™</sup>
        </div>
        <div className="text-[9px] font-medium uppercase tracking-[0.18em] text-[#8A7F76]">
          A BrightHarbor creation
        </div>
      </div>
    </div>
  );
}

export function SiteFooter() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#2C2A28]/10 bg-[#FBF4E8] px-6 py-7 text-center"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-1.5">
        <span className="text-[10px] font-semibold uppercase tracking-[0.22em] text-[#A84A32]">
          A BrightHarbor creation
        </span>
        <span data-testid="footer-operated-by" className="text-xs font-medium text-[#4A4540]">
          Your Life Journeys Matter is operated by BrightHarbor
        </span>
        <span className="text-xs text-[#8A7F76]">
          © 2026 BrightHarbor. Your Life Journeys Matter™. All rights reserved.
        </span>
        <nav className="mt-1 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs">
          <a href="/privacy" data-testid="footer-privacy" className="inline-block py-2 text-[#A84A32] underline-offset-2 hover:underline">Privacy Policy</a>
          <a href="/terms" data-testid="footer-terms" className="inline-block py-2 text-[#A84A32] underline-offset-2 hover:underline">Terms and Conditions</a>
          <a href="/refunds" data-testid="footer-refunds" className="inline-block py-2 text-[#A84A32] underline-offset-2 hover:underline">Refund Policy</a>
          <a href="/refund-request" data-testid="footer-refund-request" className="inline-block py-2 text-[#A84A32] underline-offset-2 hover:underline">Request a refund</a>
          <a href="mailto:support@yourlifejourneysmatter.com" data-testid="footer-contact" className="inline-block py-2 text-[#A84A32] underline-offset-2 hover:underline">support@yourlifejourneysmatter.com</a>
        </nav>
      </div>
    </footer>
  );
}
